import React from "react";
import Header from "./Header";
import { connect } from "react-redux";
import { getUserData, getLogout } from './../../redux/auth-reducer'

class HeaderContainer extends React.Component {
  render = () => <Header {...this.props} />
}

const mapSTP = (state) => ({
  isAuth: state.auth.isAuth,
  login: state.auth.login,
})

export default connect(mapSTP, { getUserData, getLogout })(HeaderContainer);